module.exports = __webpack_public_path__ + "img/wet_market.bec120dc.png";